(function () {
  function applySwatchImage(card, variantImage) {
    if (!variantImage) return;

    card.querySelectorAll('.card__media img').forEach(function (image) {
      image.src = variantImage;
      image.srcset = '';
    });
  }

  function applySwatchLinks(card, variantUrl) {
    if (!variantUrl) return;

    card.querySelectorAll('[data-card-product-link]').forEach(function (link) {
      link.href = variantUrl;
    });
  }

  function applySwatchPrice(card, swatch) {
    const price = card.querySelector('[data-card-price] .price');
    if (!price) return;

    const priceText = swatch.dataset.variantPrice;
    const compareAtText = swatch.dataset.variantCompareAtPrice;
    const priceRaw = Number(swatch.dataset.variantPriceRaw || 0);
    const compareAtRaw = Number(swatch.dataset.variantCompareAtPriceRaw || 0);
    const onSale = compareAtRaw > priceRaw;
    const available = swatch.dataset.variantAvailable === 'true';

    const regularPrice = price.querySelector('.price__regular .price-item--regular');
    const salePrice = price.querySelector('.price__sale .price-item--sale');
    const compareAtPrice = price.querySelector('.price__sale .price-item--regular');

    if (regularPrice && priceText) regularPrice.textContent = priceText;
    if (salePrice && priceText) salePrice.textContent = priceText;
    if (compareAtPrice) compareAtPrice.textContent = compareAtText || '';

    price.classList.toggle('price--on-sale', onSale);
    price.classList.toggle('price--sold-out', !available);

    const discountBadge = card.querySelector('[data-card-discount-badge]');
    if (discountBadge) {
      const discount = Number(swatch.dataset.variantDiscount || 0);
      discountBadge.hidden = !onSale;
      if (onSale) discountBadge.textContent = discount + '% OFF';
    }
  }

  function applySwatch(card, swatch) {
    applySwatchImage(card, swatch.dataset.variantImage);
    applySwatchLinks(card, swatch.dataset.variantUrl);
    applySwatchPrice(card, swatch);

    card.querySelectorAll('.product-color-variants-list li').forEach(function (item) {
      item.classList.remove('active');
      const button = item.querySelector('button[aria-pressed]');
      if (button) button.setAttribute('aria-pressed', 'false');
    });

    const activeItem = swatch.closest('li');
    if (activeItem) activeItem.classList.add('active');
    swatch.setAttribute('aria-pressed', 'true');
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-card-id]').forEach(function (card) {
      const activeSwatch = card.querySelector('.product-color-variants-list li.active button[data-variant-id]');
      if (activeSwatch) applySwatch(card, activeSwatch);
    });
  });

  document.addEventListener('click', function (event) {
    const swatch = event.target.closest('.product-color-variants-list button[data-variant-id]');
    if (!swatch) return;

    const card = swatch.closest('[data-product-card-id]');
    if (!card) return;

    applySwatch(card, swatch);
  });
})();
